import { render, staticRenderFns } from "./Transactions2.vue?vue&type=template&id=51a3291f"
import script from "./Transactions2.vue?vue&type=script&lang=js"
export * from "./Transactions2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports